import {Component, Injector, Input, OnChanges, OnInit} from '@angular/core';
import {FrontendDropdownComponent} from "../frontend-dropdown/frontend-dropdown.component";
import {ListResponse} from "../../../network/service/list.response";
import {ValidationService} from "../../../util/service/validation/validation-service";

@Component({
  selector: 'app-frontend-select',
  standalone: false,
  templateUrl: './frontend-select.component.html',
  styleUrls: ['./frontend-select.component.scss']
})
export class FrontendSelectComponent extends FrontendDropdownComponent implements OnInit, OnChanges {
  @Input()
  protocolMethod = 'GET';
  @Input()
  microservice?: string;
  @Input()
  version?: string;
  @Input()
  controller?: string;
  @Input()
  method?: string;
  @Input()
  orderByField?: string;
  @Input()
  orderByType: string = 'DESC';

  constructor(injector: Injector, validationService: ValidationService) {
    super(injector, validationService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnChanges(changes: any) {
    if (changes.method && !changes.method.firstChange) {
      this.selectedOptions = [];
      this.options = [];
    }
    if (this.autoSelectLatest) {
      this.onQueryChanged();
    }
  }

  override loadOnline() {
    super.loadOnline();
  }

  onQueryChanged(event?: any) {
    if (this.disabled) {
      return;
    }
    let query: any = [];
    for (let i = 0; i < this.searchOnKey!.split(',').length; i++) {
      query.push({
        Field: this.searchOnKey!.split(',')[i],
        Type: 'LIKE',
        Value: '%' + (event ?? '') + '%'
      });
      break;
    }
    (this.protocolMethod === 'GET' ? this.serviceApi.getSelect(this.microservice!, this.version!, this.controller!, this.method!, undefined) : this.serviceApi.postSelect(this.microservice!, this.version!, this.controller!, this.method!, {
      Filter: {
        Type: 'OR',
        Values: query
      },
      Order: {
        Field: this.orderByField ?? 'ModifyDate',
        Type: this.orderByType ?? 'DESC'
      }
    })).subscribe((res: ListResponse<any>) => {
      this.options = res.data ?? [];
      this.refreshCustom();
      if (this.autoSelectLatest && this.options && this.options.length > 0 && (!this.selectedOptions || this.selectedOptions.length === 0)) {
        this.autoSelectLatest = false;
        this.selectedOptions = [this.options[0]];
        this.onSelected.emit(this.options[0]);
      }
    });
  }

  onChange(event: any) {
    if (event === undefined || !(event instanceof Event)) {
      this.onSelected.emit(event);
      this.valueChange.emit(this.value);
    }
  }
}
